module.exports = __webpack_public_path__ + "static/media/Villa-Inle.9f8a5418.png";